// Decision 87 #1: global search. One call, public.search_all, finds every kind of record (the database puts the best
// match first: an exact identifier before a part of one). The top bar and the Search screen share it.
import { dataClient } from "./supabase";

export type SearchKind = "animal" | "invoice" | "lot" | "credit_note" | "payment" | "delivery" | "document" | "proposal" | "query" | "seller" | "auction";
export type SearchHit = { kind: SearchKind; id: string; title: string; meta: string | null; link: string; exact?: boolean };

/** The heading of each kind's group, in the owner's words. */
const SEARCH_GROUPS: Record<SearchKind, string> = {
  animal: "Animals", invoice: "Invoices", lot: "Lots", credit_note: "Credit notes", payment: "Payments", delivery: "Deliveries",
  document: "Documents", proposal: "Cards", query: "Queries", seller: "Sellers", auction: "Auctions"
};

export const searchKey = (q: string) => ["search", q] as const;

export async function searchAll(q: string): Promise<SearchHit[]> {
  const { data, error } = await dataClient.rpc("search_all", { p_q: q });
  if (error) throw new Error(error.message);
  return (data ?? []) as SearchHit[];
}

/** Groups the hits by kind, in the order each kind's first hit came back, keeping the order within a group. */
export function groupHits(hits: SearchHit[]): { kind: SearchKind; title: string; hits: SearchHit[] }[] {
  const groups = new Map<SearchKind, SearchHit[]>();
  for (const h of hits) {
    if (!(h.kind in SEARCH_GROUPS)) continue;
    groups.set(h.kind, [...(groups.get(h.kind) ?? []), h]);
  }
  return [...groups].map(([kind, list]) => ({ kind, title: SEARCH_GROUPS[kind], hits: list }));
}
